// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__ixgIN","tab":"Tabs_tab__3A9ai","tabActive":"Tabs_tabActive__sfL-t"};